/**
 * Strategy Entity Definition
 */
import { z } from "zod";
import { PricingModelSchema, StrategyAssetSchema, StrategyLocalizationSchema, StrategySchema, } from "../schemas/bot-config.schemas";
import { StrapiEntitySchema, StrapiIdSchema, StrapiMediaSchema } from "../schemas/common.schemas";
import { defineEntity } from "./core";
import { ExchangeEntityDef } from "./exchange.entity";
// PricingModel entity
const PricingModelEntityDef = defineEntity({
    name: "pricing-model",
    schema: PricingModelSchema,
    relations: {},
});
// StrategyLocalization entity
const StrategyLocalizationEntityDef = defineEntity({
    name: "strategy-localization",
    schema: StrategyLocalizationSchema,
    relations: {},
});
// StrategyAsset entity
const StrategyAssetEntityDef = defineEntity({
    name: "strategy-asset",
    schema: StrategyAssetSchema,
    relations: {},
});
// StrapiMedia entity (for logo, images, banner)
const StrapiMediaEntityDef = defineEntity({
    name: "strapi-media",
    schema: StrapiMediaSchema,
    relations: {},
});
// Signal entity
const SignalSchema = StrapiEntitySchema.extend({
    type: z.string().nullish(),
    message: z.string().nullish(),
    data: z.record(z.string(), z.unknown()).nullish(),
});
const SignalEntityDef = defineEntity({
    name: "signal",
    schema: SignalSchema,
    relations: {},
});
// Owner entity (minimal)
const OwnerSchema = z.object({ id: StrapiIdSchema });
const OwnerEntityDef = defineEntity({
    name: "owner",
    schema: OwnerSchema,
    relations: {},
});
export const StrategyEntityDef = defineEntity({
    name: "strategy",
    schema: StrategySchema,
    relations: {
        exchanges: { type: "many", entity: () => ExchangeEntityDef },
        logo: { type: "one", entity: () => StrapiMediaEntityDef, nullable: true },
        images: { type: "many", entity: () => StrapiMediaEntityDef },
        banner: { type: "one", entity: () => StrapiMediaEntityDef, nullable: true },
        pricingModels: { type: "many", entity: () => PricingModelEntityDef },
        owner: { type: "one", entity: () => OwnerEntityDef, nullable: true },
        assets: { type: "many", entity: () => StrategyAssetEntityDef },
        localizations: { type: "many", entity: () => StrategyLocalizationEntityDef },
        signals: { type: "many", entity: () => SignalEntityDef },
    },
});
// Re-export internal entities for nested populate type inference
export { PricingModelEntityDef, SignalEntityDef, StrapiMediaEntityDef, StrategyAssetEntityDef, StrategyLocalizationEntityDef, };
